import React, { FC, ReactNode } from 'react'

export const MockGraphCover: FC<{ coverText: string; children: ReactNode }> = ({
  coverText,
  children,
}) => (
  <div className="relative h-full">
    <h2 className={`
      absolute z-40 flex h-full w-full items-center justify-center text-4xl font-medium
    `}>
      {coverText}
    </h2>
    <div className="h-full cursor-none opacity-40">{children}</div>
  </div>
)
